<template>
  <div class="page-container">
    <div class="query-title">经销商市场支持费用查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <TableCommon
          title="结果清单"
          :custome-config="() => vxeShowCustom('xTable')"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          />
        </TableCommon>
      </div>
    </div>

  </div>
</template>

<script>
import { apiMarketSupport } from '@/api/sap/dealer'
import tableMixins from '@/utils/tableMixins'

import pageConfig, { pageSearch } from './config/marketSupport'
import { frontExport } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    exportExcel() {
      frontExport(this.gridOptions.columns, this.gridOptions.data)
    },
    async queryData(page, ranges) {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...ranges
      }
      const res = await apiMarketSupport(params)
      this.gridOptions.data = res.data
      if (res.msgtype === 'E') {
        this.$message.error(res.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/dealer-manage/marketSupport.vue